// JsFromRoutes CacheKey 9cc9f36de6adae25353227c5d4e7eef9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/setup/summary'),
}
